import {cn} from '@delorand/utils/cn';
import {CheckIcon} from '@heroicons/react/24/solid';

const Checkbox = ({
  checked,
  handleChange = () => {},
  disabled,
}: {
  checked: boolean;
  handleChange?: () => void;
  disabled?: boolean;
}) => {
  return (
    <div className="w-fit">
      <button
        disabled={disabled}
        type="button"
        onClick={handleChange}
        className={cn(
          `group flex size-6 cursor-pointer items-center justify-center rounded-lg border border-neutral-500`,
          'p-0.5 shadow-xs hover:opacity-80 disabled:opacity-20'
        )}
      >
        {checked && (
          <CheckIcon
            width={'90%'}
            strokeWidth={3}
            className="stroke-black dark:stroke-white"
          />
        )}
      </button>
    </div>
  );
};

export default Checkbox;
